import React from 'react';
import { Box, Typography, Card, Avatar } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { useTranslation } from "react-i18next";

const Header = ({ title, subtitle, selectedGuest, agent }) => {
  const { t } = useTranslation();

  function mixNames(firstName = '', middleName = '', lastName = '') {
    return [firstName, middleName, lastName]
      .filter(Boolean) 
      .join(' '); 
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
      <Box>
        <Box sx={{ width: 'auto' }}>
          <Typography variant="h4" sx={{ fontWeight: 600, fontSize: '30px' }}>
            {title}
          </Typography>
        </Box>
        <Box sx={{ width: 'auto', marginTop: '20px' }}>
          <Typography
            variant="text-large"
            sx={{
              color: '#667085',
              fontSize: '18px',
              fontWeight: 300,
            }}
          >
            {subtitle}
          </Typography>
        </Box>
      </Box>

      {/* User card on the right */}
      <Card sx={{ display: 'flex', alignItems: 'center', padding: '10px', border: '1px solid #EAECF0' }}>
        <Avatar sx={{ backgroundColor: '#EFFCF9', marginRight: '10px' }}>
          <PersonIcon sx={{ color: '#4AA1B3', fontSize: 24 }} />
        </Avatar>
        {agent.Contact_Name__r &&
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box>
              <Typography variant="body2" sx={{ color: '#667085', fontSize: '12px' }}>
                {t("Logged-in Agent")}:
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '14px', color: '#101828' }}>
                {agent?.Contact_Name__r?.Name}
              </Typography>
            </Box>

            {selectedGuest && (
              <Box
                sx={{
                  width: '1px',
                  height: '40px',
                  backgroundColor: '#EAECF0',
                  marginX: '16px',
                }}
              />
            )}
          </Box>
        }
        {selectedGuest &&
          <Box>
            <Typography variant="body2" sx={{ color: '#667085', fontSize: '12px' }}>
              {t("Selected Guest")}:
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '14px', color: '#101828' }}>
              {mixNames(
                selectedGuest?.First_Name__c,
                selectedGuest?.Middle_Name__c,
                selectedGuest?.Last_Name__c
              )}
            </Typography>
          </Box>
        }
      </Card>
    </Box>
  );
};

export default Header;